var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var StringParam = {
    decode: function (value) {
        if (Array.isArray(value)) {
            return value.join(',');
        }
        else if (value !== null && value !== undefined) {
            return value.toString();
        }
        return null;
    },
    default: function (value) { return (__assign(__assign({}, StringParam), { _defaultValue: value })); },
};
export var NumberParam = {
    decode: function (value) {
        if (typeof value === 'number') {
            return value;
        }
        else if (typeof value === 'string' && value !== '') {
            return parseFloat(value);
        }
        return null;
    },
    default: function (value) { return (__assign(__assign({}, NumberParam), { _defaultValue: value })); },
};
export var BooleanParam = {
    decode: function (value) {
        if (typeof value === 'boolean') {
            return value;
        }
        else if (typeof value === 'string') {
            return value === 'true';
        }
        else if (typeof value === 'number') {
            return value !== 0;
        }
        return null;
    },
    default: function (value) { return (__assign(__assign({}, BooleanParam), { _defaultValue: value })); },
};
export var ArrayParam = {
    decode: function (value) {
        if (Array.isArray(value)) {
            return value;
        }
        else if (value !== undefined && value !== null && value !== '') {
            return [value];
        }
        else if (value === '') {
            return [];
        }
        return null;
    },
    default: function (value) { return (__assign(__assign({}, ArrayParam), { _defaultValue: value })); },
};
export var StringArrayParam = {
    decode: function (value) {
        var a = ArrayParam.decode(value);
        return a ? a.map(function (v) { return (v !== null && v !== undefined ? v.toString() : ''); }) : null;
    },
    encode: ArrayParam.encode,
    default: function (value) { return (__assign(__assign({}, StringArrayParam), { _defaultValue: value })); },
};
export var NumberArrayParam = {
    decode: function (value) {
        var a = ArrayParam.decode(value);
        return a
            ? a.map(function (v) {
                if (typeof v === 'number') {
                    return v;
                }
                else if (typeof v === 'string') {
                    return parseFloat(v);
                }
                return NaN;
            })
            : null;
    },
    encode: ArrayParam.encode,
    default: function (value) { return (__assign(__assign({}, NumberArrayParam), { _defaultValue: value })); },
};
export var JsonParam = {
    encode: function (value) { return JSON.stringify(value); },
    decode: function (value) {
        if (typeof value === 'string') {
            return JSON.parse(value);
        }
        else if (Array.isArray(value)) {
            return JSON.parse(value.join(','));
        }
        else {
            return value;
        }
    },
    default: function (value) { return (__assign(__assign({}, JsonParam), { _defaultValue: value })); },
};
